/**
 * Detect which auth back-end the current dtrader-c session was bootstrapped through.
 *
 *  - 'oauth2'  -> OAuth2 PKCE delivered an `oauth2_access_token` (Bearer used by the V2 OTP WS).
 *  - 'legacy'  -> classic V1 path (per-account `accountsList` token map, binary WS authorize).
 *
 * Mirrors the logic used by PU/DBOT so all three apps agree on the marker. Persisted in localStorage
 * by the host-side postMessage handshake (`iframe-bridge`).
 */

const AUTH_FLOW_KEY = 'auth_flow';
const OAUTH2_ACCESS_TOKEN_KEY = 'oauth2_access_token';

export type TAuthFlow = 'legacy' | 'oauth2';

export const getAuthFlow = (): TAuthFlow => {
    try {
        const stored = localStorage.getItem(AUTH_FLOW_KEY);
        if (stored === 'oauth2' || stored === 'legacy') return stored;
        if (localStorage.getItem(OAUTH2_ACCESS_TOKEN_KEY)) return 'oauth2';
    } catch {
        /* ignore */
    }
    return 'legacy';
};

export const isV2AuthFlow = (): boolean => getAuthFlow() === 'oauth2';

export const getActiveOAuth2Token = (): string | null => {
    try {
        return localStorage.getItem(OAUTH2_ACCESS_TOKEN_KEY);
    } catch {
        return null;
    }
};

export const getActiveOAuth2AccountId = (): string | null => {
    try {
        return localStorage.getItem('oauth2_active_account_id') || localStorage.getItem('active_loginid') || null;
    } catch {
        return null;
    }
};

export const clearAuthFlow = (): void => {
    try {
        localStorage.removeItem(AUTH_FLOW_KEY);
        localStorage.removeItem(OAUTH2_ACCESS_TOKEN_KEY);
        localStorage.removeItem('oauth2_access_token_expires_at');
        localStorage.removeItem('oauth2_active_account_id');
    } catch {
        /* ignore */
    }
};
